import * as PIXI from "pixi.js";
import {config} from "../config";
import data from "./configs/data";
import {Button} from "./controlElements/Button";

export class InfoMenu extends PIXI.Container {

    public static getInstance(): InfoMenu {
        if (!InfoMenu.OBJ_INSTANCE) {
            InfoMenu.OBJ_INSTANCE = new InfoMenu();
        }
        return InfoMenu.OBJ_INSTANCE;
    }

    private static OBJ_INSTANCE: InfoMenu;
    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private readonly CLOSE_BUTTON_POSITION = new PIXI.Point(307, -195);
    private readonly HEADER_TEXT_POSITION = new PIXI.Point(0, -172);
    private readonly CONTENT_TEXT_POSITION = new PIXI.Point(0, 0);
    private readonly PLAY_BUTTON_POSITION = new PIXI.Point(0, 172);

    private readonly PLAY_TEXT_STYLE = {
        fontSize: 26,
        fontFamily: "RobotoBold",
        fontWeight: "500",
        fill: "#000000",
    };

    private readonly HEADER_TEXT_STYLE = {
        fontSize: 41,
        fontFamily: "RobotoBold",
        fontWeight: "700",
        fill: "#fff",
    };

    private readonly CONTENT_TEXT_STYLE = {
        fontSize: 22,
        lineHeight: 18,
        fontFamily: "RobotoBold",
        fontWeight: "700",
        fill: "#fff",
    };

    private constructor() {
        super();
        this.createAndAddBackgroundBlend();
        this.createAndAddCloseButton();
        this.createAndAddPlayButton();
        this.createAndAddHeader();
        this.createAndAddContent();
        this.hide();
    }

    public toggleVisibility(): void {
        this.visible = !this.visible;
    }

    public hide(): void {
        this.visible = false;
    }

    private createAndAddCloseButton(): void {
        const contentClose = new Button(data.images.closeInfoMenu, data.images.closeInfoMenuHover,
            data.images.closeInfoMenuClick, data.images.closeInfoMenu, data.audios.buttonClicked);
        contentClose.position = this.CLOSE_BUTTON_POSITION;
        contentClose.subscribeOnClicked(() => {
            this.hide();
        });
        this.addChild(contentClose);
    }

    private createAndAddHeader(): void {
        const header = new PIXI.Text("HOW TO PLAY", this.HEADER_TEXT_STYLE);
        header.position = this.HEADER_TEXT_POSITION;
        header.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(header);
    }

    private createAndAddContent(): void {
        const content = new PIXI.Text("1. Connect to our platform with your wallet." +
            "\n \n" +
            "2. Choose the bet value you want to place." +
            "\n \n" +
            "3. Potential win will be displayed in the proper window." +
            "\n \n" +
            "4. You can predict the numbers Below or Above your pick." +
            "\n \n" +
            "5. Click \"ROLL\" button to start the game." +
            "\n \n" +
            "6. if you predict the result of the draw correctly," +
            "\n \n" +
            "    you win the " + config.displayCurrency + "." +
            "", this.CONTENT_TEXT_STYLE);
        content.position = this.CONTENT_TEXT_POSITION;
        content.anchor = this.DEFAULT_ANCHOR_POINT;
        this.addChild(content);
    }

    private createAndAddPlayButton(): void {
        const playButton = new Button(data.images.playInfoMenu, data.images.playInfoMenuHover,
            data.images.playInfoMenuClick, data.images.playInfoMenu, data.audios.buttonClicked);
        playButton.position = this.PLAY_BUTTON_POSITION;
        playButton.label = new PIXI.Text("PLAY", this.PLAY_TEXT_STYLE);
        playButton.label.anchor = this.DEFAULT_ANCHOR_POINT;
        playButton.subscribeOnClicked(() => {
            this.hide();
        });
        this.addChild(playButton);
    }

    private createAndAddBackgroundBlend(): void {
        const graphics = new PIXI.Graphics();
        graphics.lineStyle(2, 0x2af1ff, 1);
        graphics.beginFill(0x000000);
        graphics.drawRect(-340, -230,
            680, 460);
        graphics.endFill();
        const backgroundBlend = new PIXI.Sprite(graphics.generateCanvasTexture());
        backgroundBlend.anchor = this.DEFAULT_ANCHOR_POINT;
        backgroundBlend.interactive = true;
        this.addChild(backgroundBlend);
    }
}



// WEBPACK FOOTER //
// ./src/app/InfoMenu.ts